import { Component, inject } from '@angular/core';
import { CreateAufgabeFormService } from '../../../create-aufgabe-dialog/create-aufgabe.formservice';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';

@Component({
	selector: 'schir-int-client-aufgabe-schuldtitel-editor',
	templateUrl: './aufgabe-schuldtitel-editor.component.html',
	styleUrls: ['./aufgabe-schuldtitel-editor.component.scss'],
	standalone: false,
})
export class AufgabeSchuldtitelEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	protected readonly formGroup = this.formService.form.controls.LFPR_SCHULDTITEL;
	protected readonly bodyControls = this.formGroup.controls.body.controls;
	protected readonly AufgabenTyp = AufgabenTyp;
}
